import { Row, Col } from 'reactstrap';
import ApexLineChart from './components/ApexLineChart';
import StatsCard from './components/StatsCard';
import UsersList from './components/usersList';

const Admin = () => {
  return (
    <div>
      <Row className="match-height">
        <Col xs="12" md="6" lg="8">
          <ApexLineChart />
        </Col>
        <Col xs="12" md="6" lg="4">
          <StatsCard cols={{ xs: '12' }} />
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <UsersList />
        </Col>
      </Row>
    </div>
  );
};

export default Admin;
